import { MutationTree } from "vuex";
import { User } from "../../shared/User";
import setAxiosHeaders from "./helpers";
import { LoginState } from "./types";

export const mutations: MutationTree<LoginState> = {
  LOGIN(state, user: User) {
    state.user = user;
    // console.log(user);
    localStorage.user = JSON.stringify(user);
    localStorage.token = user.token;
  },
  LOGOUT(state, user: User) {
    state.user = undefined;
    // localStorage.removeItem("user"); // = undefined;
    // localStorage.removeItem("token"); // = undefined;
    localStorage.removeItem("sites"); // = undefined;
    localStorage.removeItem("enseignes"); // = undefined;
    localStorage.removeItem("sirets"); // = undefined;
    localStorage.removeItem("groupements"); // = undefined;
    state.sites = [];
    state.enseignes = [];
    state.sirets = [];
    setAxiosHeaders("");
  },
  CLEAR(state, user: User) {
    state.user = undefined;
    localStorage.removeItem("user"); // = undefined;
    localStorage.removeItem("token"); // = undefined;
    localStorage.removeItem("sites"); // = undefined;
    localStorage.removeItem("enseignes"); // = undefined;
    localStorage.removeItem("sirets"); // = undefined;
    localStorage.removeItem("groupements"); // = undefined;
    state.sites = [];
    state.enseignes = [];
    state.sirets = [];
    setAxiosHeaders("");
  },
  SET_SITES(state, sites: []) {
    state.sites = sites;
    localStorage.sites = JSON.stringify(sites);
  },
  SET_ENSEIGNES(state, enseignes: []) {
    state.enseignes = enseignes;
    localStorage.enseignes = JSON.stringify(enseignes);
  },
  SET_SIRETS(state, sirets: []) {
    state.sirets = sirets;
    localStorage.sirets = JSON.stringify(sirets);
  },
  SET_GROUPEMENTS(state, groupes: []) {
    state.groupements = groupes;
    localStorage.groupements = JSON.stringify(groupes);
  },
  LOADING(state, loadingState) {
    state.loading = loadingState;
  },
  SET_LANGUAGE(state, language) {
    state.language = language;
    localStorage.language = language;
  }
};
